import { useState } from 'react';
import { getCurrentLocation } from './utils/map';
import axios from "axios";

type SummaryApiResponse = {
    summary: {
        id: string;
        fb_id: string;
        fb_name: string;
        short_id: string;
        is_public: boolean;
        checkin_count: number;
        last_checkin_date: string;
        icon_path: string;
    }[];
};

type CheckinApiResponse = {
    result: boolean;
    errorCode: number;
    url: string;
};

type StampCardApiResponse = {
    stamps: any;
    card: any;
    pager: any;
};

export function useStamps() {
    const [loading, setLoading] = useState(false);

    async function checkin(id: number) {
        setLoading(true);
        const coord = await getCurrentLocation();
        try {
            const { data } = await axios.post<CheckinApiResponse>(`/api/map/spots/${id}/checkin`, coord);
            return data;
        } catch (e) {
            throw e;
        } finally {
            setLoading(false);
        }
    }

    async function summary(id: number, order: number = 1, page: number = 1): Promise<CheckinUser[]> {
        setLoading(true);
        try {
            const { data: { summary } } = await axios.get<SummaryApiResponse>(`${window.location.origin}/api/map/spots/${id}/checkins?order=${order}&page=${page}`);
            if (summary) {
                return summary;
            } else {
                return [];
            }
        } catch (e) {
            throw e;
        } finally {
            setLoading(false);
        }
    }

    async function getCard(id?: number, page?: number): Promise<StampCardApiResponse> {
        setLoading(true);

        try {
            const params = page ? `?page=${page}` : '';
            const { data } = await axios.get(`/api/map/stampcards/${id ?? ''}${params}`);
            return data;
        } catch (e) {
            throw e;
        } finally {
            setLoading(false);
        }
    }

    return { checkin, summary, getCard, loading };
};
